import { render } from "./Import_Item_Catalog.vue?vue&type=template&id=5a10801c"
import script from "./Import_Item_Catalog.vue?vue&type=script&lang=js"
export * from "./Import_Item_Catalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__